import {
  FareEstimateValidatorApiModel,
  CallbackRequestApiModel,
} from '../api-models/FareEstimateValidatorApiModel';
import {
  FareEstimateValidator,
  CallbackResponse,
} from '../entities/FareEstimateValidator';

export function toCallbackRequestResponse(
  response: CallbackRequestApiModel,
): CallbackResponse {
  return {
    result: response.result,
    prevCallbackReqIdPresent: response.prev_callback_req_id_present,
    callbackRequestId: response.callback_request_id,
    isExistingCust: response.is_existing_cust,
    brand: response.brand,
    leadEntryCreated: response.lead_entry_created,
    sendUnregisteredEvent: response.send_unregistered_event,
  };
}

export function toFareEstimateResponse(
  response: FareEstimateValidatorApiModel,
): FareEstimateValidator {
  return {
    redirectUrl: response.fare_estimate_url,
    callbackRequestData: toCallbackRequestResponse(
      response.callback_request_response,
    ),
  };
}
